module.exports = __webpack_public_path__ + "img/games-3.3da229ee.jpg";